'use strict';

const FORM_SELECTOR_MOBILE = '.date-picker';
const FORM_SELECTOR_DESKTOP = '.date-picker__desktop';

const CHECKED_RADIO = 'input[type = radio]:checked'
const DESKTOP_BUTTON = '.date-picker__inner-desktop'

export function init() {
    const form_mobile = document.querySelector(FORM_SELECTOR_MOBILE);
    const form_desktop = document.querySelector(FORM_SELECTOR_DESKTOP);

    if (form_mobile !== null) {
        form_mobile.addEventListener('submit', e => {
            e.preventDefault()
            let performanceId = null
            let customBookingURL = null

            const radio_mobile = form_mobile.querySelector(CHECKED_RADIO); // Get checked radio button

            if (radio_mobile !== null) {
                performanceId = radio_mobile.value;
                customBookingURL = radio_mobile.dataset.customBookingLink;
            }

            if (customBookingURL) {
                window.location = customBookingURL;
            } else {
                window.location = `${AppConfig.boDomain}booking/production/${performanceId}`;
            }
        })
    }

    if (form_desktop !== null) {
        form_desktop.addEventListener('submit', e => {
            e.preventDefault()
            let performanceId = null;
            let customBookingURL = null;

            if (e.submitter !== null) {
                performanceId = e.submitter.value;
                customBookingURL = e.submitter.dataset.customBookingLink;
            }

            if (customBookingURL) {
                window.location = customBookingURL;
            } else {
                window.location = `${AppConfig.boDomain}booking/production/${performanceId}`;
            }
        })
    }
}
